import { Component, ElementRef, input, viewChild } from '@angular/core';
import { ReactWrapperComponent } from '@examdojo/core/react-wrapper';
import type { CollabUser } from '@examdojo/core/tiptap-react-ui-components/lib/collab-config';
import { ThreadsPanel } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui/threads-panel';
import type { TiptapCollabProvider } from '@tiptap-pro/provider';
import type { Editor } from '@tiptap/core';
import { createElement, type ReactElement } from 'react';

@Component({
  selector: 'dojo-tiptap-threads-panel',
  standalone: true,
  template: `<div #threadsPanelContainer class="h-full"></div>`,
  host: { class: 'block h-full' },
})
export class TiptapThreadsPanelComponent extends ReactWrapperComponent {
  readonly mountElementRef = viewChild.required<ElementRef>('threadsPanelContainer');

  readonly editor = input.required<Editor>();
  readonly provider = input.required<TiptapCollabProvider>();
  readonly user = input.required<CollabUser>();

  protected readonly reRenderTriggers = [this.editor, this.provider, this.user];

  protected renderReactElement(): ReactElement {
    return createElement(ThreadsPanel, {
      editor: this.editor(),
      provider: this.provider(),
      userName: this.user().name,
      userAvatar: this.user().avatarUrl,
    });
  }
}
